<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Turnaround Data Loading...
  </div>
  <div v-else class="animated fadeIn">
    <basic-heading
      :title="`${turnaround.sample_type.name}: ${turnaround.name}`"
      class="mb-3"
    >
      <template #right-content>
        <header-button-group :button_config="button_config">
          <template #post_buttons>
            <button
              v-show="checkPermission('delete turnaround')"
              title="Delete turnaround"
              class="btn btn-danger ml-1"
              @click="showDeleteModal"
            >
              <i class="fal fa-trash" />
            </button>
          </template>
        </header-button-group>
      </template>
    </basic-heading>
    <permission-alert-gate :permissions="'read turnaround'">
      <template #gated-content>
        <turnaround-card :turnaround="turnaround" />
        <turnaround-detail-cardstack
          :turnaround_sample_type_id="turnaround.sample_type_id"
        />
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import Vue from "vue";
import VueNotifications from "vue-notifications";
import BasicHeading from "@/components/shared/BasicHeading";
import HeaderButtonGroup from "@/components/shared/headerbuttons/HeaderButtonGroup";
import PermissionAlertGate from "@/components/permission/PermissionAlertGate";
import TurnaroundCard from "@/components/lab/turnaround/TurnaroundCard";
import TurnaroundDetailCardstack from "@/components/lab/turnaround/TurnaroundDetailCardstack";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { getModel } from "@/shared/fetch-utils";
import { LabRepositoryFactory } from "@/repositories/lab/LabRepositoryFactory";
import { notificationOptions } from "@/shared/toast-notification-options";
import { turnaroundNotifications } from "@/shared/notifications";

Vue.use(VueNotifications, notificationOptions);

const TurnaroundRepository = LabRepositoryFactory.get("turnaround");

export default {
  name: "TurnaroundDetail",
  components: {
    BasicHeading,
    HeaderButtonGroup,
    PermissionAlertGate,
    TurnaroundCard,
    TurnaroundDetailCardstack,
  },
  data() {
    return {
      loading: true,
      turnaround_id: this.$route.params.turnaround_id || null,
      turnaround: null,
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-list",
            linkto: "/turnarounds",
            title: "Turnaround list",
          },
          {
            icon: "fa-pencil",
            linkto: `/turnarounds/${this.turnaround_id}/edit`,
            title: "Edit turnaround",
            variant: "warning",
            permission: this.checkPermission("edit turnaround"),
          },
        ],
      };
    },
  },
  methods: {
    checkPermission(permission) {
      return AccessControlCheck.checkPermission(permission);
    },
    showDeleteModal() {
      this.$bvModal
        .msgBoxConfirm(
          "You are about to remove this turnaround. Do you want to continue?",
          {
            title: "Are you sure?",
            modalClass: ["modal-danger"],
            size: "sm",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            centered: true,
          }
        )
        .then(async (confirm) => {
          if (confirm) {
            try {
              await TurnaroundRepository.suspend(this.turnaround_id);

              this.deleteSuccess();
              this.$router.push("/turnarounds");
            } catch ({ response }) {
              const { status, data } = response.response;

              this.$bvToast.toast(`Code: ${status}. ${data.error}`, {
                title: "Server Error.",
                variant: "danger",
              });
            }
          }
        });
    },
  },
  async created() {
    this.loading = true;

    this.turnaround = await getModel({
      model_type: "turnaround",
      id: this.turnaround_id,
      message: this.$bvToast,
    });

    this.turnaround ? (this.loading = false) : this.$router.back();
  },
  notifications: turnaroundNotifications,
};
</script>
